import firebase, {db, auth, fc, st} from './connection'
import store from '../store.js'

export default {
    uploadFile(uid, guid, item, preceded) {
        if (preceded != null) {
			let tempo = st.ref(uid + '/photo/' + preceded.name);
			tempo.delete();
        }
        
		let ref = db.collection('users').doc(uid);
		let uploadTask = st.ref(uid + '/photo/' + guid).put(item);

        store.dispatch('setFileUploading', true);
        store.dispatch('setFileUploaded', false);

		uploadTask.on('state_changed', snapshot => {
						let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                        store.dispatch('setFileProgress', progress);
					}, error => {
                        console.log(error);
                        store.dispatch('setFileUploading', false);
					}, () => {
                        uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
                                ref.update({
                                        photo: {
                                            name: guid,
                                            url: downloadURL
                                        }
                                    })
                                    .then( () => {
                                        store.dispatch('setFileUploading', false);
                                        store.dispatch('setFileUploaded', true);
                                    })
                                    .catch( error => {
                                        console.log(error);
                                    });
                            });
					});
    },
    
    removeFile(uid, fileName) {
		let tempo = st.ref(uid + '/photo/' + fileName);
		tempo.delete();

		let ref = db.collection('users').doc(uid);

		return ref.update({photo: null})
					.then( () => {
						return true;
					})
					.catch(error => {
						return error;
					});
    },
    
    updateName(uid, name) {
        let ref = db.collection('users').doc(uid);

        return ref.update({name: name})
					.then( () => {
						return true;
					})
					.catch(error => {
						return error;
					});
    },

    updateBio(uid, bio) {
        let ref = db.collection('users').doc(uid);

        return ref.update({bio: bio})
					.then( () => {
						return true;
					})
					.catch(error => {
						return error;
					});
	},
	
	updateSuperPower(uid, payload) {
        let ref = db.collection('users').doc(uid);

        return ref.update({superPower: payload})
					.then( () => {
						return true;
					})
					.catch(error => {
						return error;
					});
	},
	
	updateProfession(uid, payload) {
        let ref = db.collection('users').doc(uid);

        return ref.update({profession: payload})
					.then( () => {
						return true;
					})
					.catch(error => {
						return error;
					});
	},
	
	updateCountry(uid, payload) {
        let ref = db.collection('users').doc(uid);

        return ref.update({country: payload})
					.then( () => {
						return true;
					})
					.catch(error => {
						return error;
					});
	},
	
	updateAge(uid, payload) {
        let ref = db.collection('users').doc(uid);

        return ref.update({age: payload})
					.then( () => {
						return true;
					})
					.catch(error => {
						return error;
					});
	},
	
	updateDescription(uid, payload) {
        let ref = db.collection('users').doc(uid);

        return ref.update({description: payload})
					.then( () => {
						return true;
					})
					.catch(error => {
						return error;
					});
    },

    updateLinkedin(uid, linkedin) {
        let ref = db.collection('users').doc(uid);

        return ref.update({linkedin: linkedin})
					.then( () => {
						return true;
					})
					.catch(error => {
						return error;
					});
    },

    updateAttributes(uid, attributes) {
        let ref = db.collection('users').doc(uid);

        return ref.update({attributes: attributes})
					.then( () => {
						return true;
					})
					.catch(error => {
						return error;
					});
	},
	
	updateTop3(uid, top3) {
        let ref = db.collection('users').doc(uid);

        return ref.update({top3: top3})
					.then( () => {
						return true;
					})
					.catch(error => {
						return error;
					});
	},
	
	updateMytop(uid, mytop) {
        let ref = db.collection('users').doc(uid);

        return ref.update({mytop: mytop})
					.then( () => {
						return true;
					})
					.catch(error => {
						return error;
					});
	},
	
	updatePlanner(uid, planner) {
        let ref = db.collection('users').doc(uid);

        return ref.update({planner: planner})
					.then( () => {
						return true;
					})
					.catch(error => {
						return error;
					});
    },

    updateConcepts(uid, concepts) {
        let ref = db.collection('users').doc(uid);

        return ref.update({concepts: concepts})
					.then( () => {
						return true;
					})
					.catch(error => {
						return error;
					});
	},
	
	updateGoals(uid, goals) {
        let ref = db.collection('users').doc(uid);

        return ref.update({goals: goals})
					.then( () => {
						return true;
					})
					.catch(error => {
						return error;
					});
    },

    updateValues(uid, values) {
        let ref = db.collection('users').doc(uid);

        return ref.update({values: values})
					.then( () => {
						return true;
					})
					.catch(error => {
						return error;
					});
    },

    updateEmail(uid, email) {
        let ref = db.collection('users').doc(uid);

        return auth.currentUser.updateEmail(email)
					.then( () => {
						return ref.update({email: email})
                                    .then( () => {
                                        return true;
                                    })
                                    .catch(error => {
                                        return error;
                                    });
					})
					.catch(error => {
                        console.log(error)
						return error;
					});
    },

    updatePassword(email, previous, password) {
		const credential = firebase.auth.EmailAuthProvider.credential(email, previous);

		return auth.currentUser.reauthenticateWithCredential(credential)
				.then( () => {
					return auth.currentUser.updatePassword(password)
                                            .then( () => {
                                                return true;
                                            })
                                            .catch(error => {
                                                return error;
                                            });
				})
				.catch(error => {
					return error;
        		});
	},

}